import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function lockBodyScroll() {
	const body = document.querySelector('body');
	disableBodyScroll(body);
}

function unlockBodyScroll() {
	const body = document.querySelector('body');
	enableBodyScroll(body);
}

interface CustomHTMLElement extends HTMLElement {
	click(): void;
	focus(): void;
}

document.addEventListener('DOMContentLoaded', function () {
	const landingQuestion = document.querySelector('.landing-question') as HTMLElement | null;
	const isQuestionPage = landingQuestion && landingQuestion?.offsetParent !== null;
	const headerMenuToggle = document.querySelector('.header-menu-toggle') as CustomHTMLElement | null;
	const navigation = document.querySelector('.navigation') as HTMLElement | null;
	const locationLinks = document.querySelectorAll('.navigation .location-info a') as NodeListOf<CustomHTMLElement>;
	const menuItems = document.querySelectorAll('.navigation-button, .navigation a') as NodeListOf<CustomHTMLElement>;
	const locationInfo = document.querySelector('.location-info') as HTMLElement | null;


	// Add tabindex to menu items
	menuItems.forEach((item) => {
		item.setAttribute('tabindex', '-1');
	});

	locationLinks.forEach((link) => {
		link.setAttribute('tabindex', '-1');
	});

	function findNextFocusableEl() {
		if (isQuestionPage) {
			// Focus the landing question input if on the question page
			if (landingQuestion) {
				landingQuestion?.dispatchEvent(new Event('click'));
			}
		}

		return false;
	}

	function closeNavigation() {
		if (navigation) {
			if (navigation.classList.contains('has-contact')) {
				navigation.scrollTo(0, 0);
			}
			menuItems.forEach((item) => {
				item.setAttribute('tabindex', '-1');
			});
			locationLinks.forEach((link) => {
				link.setAttribute('tabindex', '-1');
			});
			navigation.classList.remove('active');
			navigation.setAttribute('aria-hidden', 'true');
			navigation.classList.remove('has-contact');
			locationInfo?.classList.remove('location-info--visible');
			locationInfo?.classList.remove('location-info--visible-opacity');
			locationLinks.forEach((link) => {
				link.setAttribute('tabindex', '-1');
			});
			if (window.screen.width > 680) {
				unlockBodyScroll();
			}
			findNextFocusableEl();
		}

		return false;
	}

	// Navigation toggle
	if (headerMenuToggle) {
		headerMenuToggle.addEventListener('click', function () {
			if (navigation) {
				menuItems.forEach((item) => {
					item.setAttribute('tabindex', '0');
				});
				locationLinks.forEach((item) => {
					item.setAttribute('tabindex', '-1');
				});
				navigation.classList.add('active');
				navigation.setAttribute('aria-hidden', 'false');
				if (window.screen.width > 680) {
					lockBodyScroll();
				}
			}
			return false;
		});
	}

	const navigationButton = document.querySelector('.navigation-button') as CustomHTMLElement | null;
	const navItems = document.querySelectorAll('.menu-item');
	navigationButton?.addEventListener("mouseenter", function () {
		navItems.forEach((item) => {
			item.classList.add('unhovered');
		});
	});
	navigationButton?.addEventListener("mouseleave", function () {
		navItems.forEach((item) => {
			item.classList.remove('unhovered');
		});
	});

	if (navigationButton) {
		navigationButton.addEventListener('click', closeNavigation);
	}

	// Close navigation when clicking outside of it & scroll down
	if (navigation) {
		if (!navigation.classList.contains('active')) {
			document.addEventListener('click', function (e) {
				if (headerMenuToggle && !headerMenuToggle.contains(e.target as Node)) {
					const navigationTop = navigation.getBoundingClientRect().top;
					if (navigationTop >= 0 && !navigation.contains(e.target as Node)) {
						closeNavigation();
					}
				}
			});
			document.addEventListener('wheel', function (e) {
				if (e.target && !navigation.contains(e.target as Node)) {
					if (navigation.classList.contains('active') && e.deltaY > 0) {
						closeNavigation();
					}
				}
			});
		}
	}

	const menuItemTypeCustom = document.querySelector('.menu-item-type-custom');
	if (menuItemTypeCustom) {
		menuItemTypeCustom.addEventListener('click', function () {
			if (navigation) {
				navigation.classList.toggle('has-contact');
				if (navigation.classList.contains('has-contact')) {
					locationLinks.forEach((link) => {
						link.setAttribute('tabindex', '0');
					});
				} 
				else {
					locationLinks.forEach((link) => {
						link.setAttribute('tabindex', '-1');
					});
				}
				setTimeout(function () {
					locationInfo?.classList.toggle('location-info--visible');
				}, 300);
				setTimeout(function () {
					locationInfo?.classList.toggle('location-info--visible-opacity');
				}, 325);
				document.getElementById('menu-secondary')?.classList.toggle('extend');
			}
			return false;
		});
	}

	// Make enter key work on navigation links and keep the focus on the link
	const navigationLinks = document.querySelectorAll('.navigation a');
	navigationLinks.forEach((link) => {
		const linkItem = link as CustomHTMLElement | null;
		if (linkItem) {
			linkItem.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') {
					e.preventDefault();
					e.stopImmediatePropagation();
					linkItem.click();
				}
			});
		}
	});

	// Keyboard controls
	document.addEventListener('keydown', function (e) {
		const headerMenuToggle = document.querySelector('.header-menu-toggle') as CustomHTMLElement | null;

		// Esc to close navigation
		if (navigation && navigation.classList.contains('active') && e.key === 'Escape') {
			navigationButton?.click();
		}
		if (navigation && navigation.classList.contains('active') && navigationButton === document.activeElement && e.key === 'Enter') {
			navigationButton?.click();
		}

		// Loop through navigation links
		const menuSocialMedia = document.querySelector('#menu-social-media');
		if (menuSocialMedia && menuSocialMedia.querySelector('a:focus')) {
			if (e.key === 'Tab' && !e.shiftKey) {
				e.preventDefault();
				const lastFocusedAnchor = menuSocialMedia.querySelector('a:focus') as HTMLElement | null;
				if (lastFocusedAnchor) {
					const listItem = lastFocusedAnchor.parentElement;
					const nextAnchor = listItem?.nextElementSibling?.querySelector('a');
					if (nextAnchor) {
						nextAnchor.focus();
					} else {
						navigationButton?.focus();
					}
				}
			}
		}

		// Handle the next focus when the header menu toggle is focused but not active
		const headerMenuToggleFocused = headerMenuToggle === document.activeElement && !navigation?.classList.contains('active');
		if (headerMenuToggleFocused) {
			if (e.key === 'Tab' && !e.shiftKey) {
				if (isQuestionPage) {
					e.preventDefault();
					e.stopImmediatePropagation(); // Prevents the focus from going to the next element
					findNextFocusableEl();
				}
			}
			if (e.key === 'Enter') {
				headerMenuToggle?.click();
			}
		}

		// Handle upward tabbing of menu close button
		const navigationButtonFocused = navigationButton === document.activeElement && navigation?.classList.contains('active');
		if (navigationButtonFocused) {
			if (e.key === 'Tab' && e.shiftKey) {
				e.preventDefault();
				e.stopImmediatePropagation(); // Prevents the focus from going to the next element
				const lastSocialLink = document.querySelector('#menu-social-media li:nth-of-type(4) a') as HTMLElement | null;
				lastSocialLink?.focus();
			}
		}
	});
});
